// extracted by css-extract-rspack-plugin
export default {"cls1":"FriendlySutdModal-cls1_3eR","cls2":"FriendlySutdModal-cls2_uWC FriendlySutdModal-cls1_3eR"};